<!--data-authenticate-user="TPM.Payroll.Export" data-authenticate-command="hide"-->
<div class="box-dash">
  <div class="row talent-payroll">
    <div class="col-lg-12">
      <div class="page-container">
        <div class="box-dash">
          <div class="grid-table-container summary-venue-schedule">
            <div class="grid-table">
              <div class="hdr-grid-row">
                <nav class="breadcrumb">
                  <ul>
                    <li><a title="Exports" class="btn-link" (click)="onBreadcrumb('step1')">Exports</a></li>
                    <li *ngIf="exportTypeFilesAvailalble || showArchivedFiles" (click)="onBreadcrumb('step2')">/ <a class="btn-link" title="Exports">{{selectedExportType}}</a></li>
                    <li *ngIf="showArchivedFiles">/ Archive</li>
                  </ul>
                </nav>
              </div>
              <div class="hdr-grid-row export-type-list" *ngIf="!selectedExportType">
                {{selectedExportType}}
                <div class="col-md-3" *ngFor="let exportType of paymentExportsTypes">
                  <div>
                    <a class="link-underline-light" (click)="onExportTypeSelected(exportType.fileName);">
                      <div >
                        <div class="folder-container ms-3">
                          <i class="export-folders fa fa-folder-open"></i>
                        </div>
                        <div class="folder-desc">
                          <span>{{exportType.fileName}}</span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="hdr-grid-row" *ngIf="(exportTypeFilesAvailalble && !showArchivedFiles)">
                <div class="col-md-12 export-type-list">
                  <div>
                    <a class="link-underline-light" (click)="onArchieveClicked();">
                      <div class="container-fluid">
                        <div class="folder-container">
                          <i class="export-folders fa fa-folder-open"></i>
                        </div>
                        <div class="folder-desc">
                          <span>Archive</span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>

              </div>


              <div class="hdr-grid-row" style="height:20px;"></div>
              <div class="container-fluid d-flex">
                <div class="row" *ngIf="(exportTypeFilesAvailalble && !showArchivedFiles && paymentExports)">
                  <div class="col-md-3 export-file" *ngFor="let exports of paymentExports">
                    <div>
                      <a class="link-underline-light" (click)="downloadFile(exports.fileName);">
                        <div>
                          <div class="file-container">
                            <i class="fa fa-cloud-download"></i>
                          </div>
                          <div class="file-desc">
                            <span>{{exports.fileName}}</span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-fluid d-flex">
                <div class="row" *ngIf="showArchivedFiles">
                  <div class="col-md-3 export-file" *ngFor="let archivedFile of archivedFiles">
                    <div>
                      <a class="link-underline-light" (click)="downloadFile(archivedFile.fileName);">
                        <div>
                          <div class="file-container">
                            <i class="fa fa-cloud-download"></i>
                          </div>
                          <div class="file-desc">
                            <span>{{archivedFile.fileName}}</span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <ul>
                    <li *ngFor="let archivedFile of archivedFiles">
                      <a (click)="downloadFile(archivedFile.fileName);">
                        <span>
                          <i class="fa fa-cloud-download"></i>
                          <span style="padding:5px;"></span>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="hdr-grid-row"
                   style="height:50px;"
                   *ngIf="(archivedFiles.length==0 && paymentExports==0 && selectedExportType!='')">
                <div class="center">
                  No Export is available to download.
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
